import * as React from "react"

const XS_BREAKPOINT = 500

export function useIsExtraSmall() {
  const [isExtraSmall, setIsExtraSmall] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${XS_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsExtraSmall(window.innerWidth < XS_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    setIsExtraSmall(window.innerWidth < XS_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!isExtraSmall
}
